import {
    MeshStandardMaterial,
    Shape,
    Mesh,
    ExtrudeGeometry,
} from 'three'

import Experience from '../Experience.js'

export default class Models {
    constructor(terrain) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.terrain = terrain


        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder({ title: 'Models', expanded: false })
        }

        this.setData()
    }

    setData() {
        this.createBuildings(this.resources.items.batiments)
    }

    createBuildings(geojson) {
        const terrain = this.terrain

        const material = new MeshStandardMaterial({
            // Enduit clair mat : l'ancien métal à 75 % reflétait le ciel et
            // donnait des volumes gris plastique.
            color: 0xcdc3b1,
            roughness: 0.88,
            metalness: 0
        })
        
        if (this.debug.active) {
            const params = {
                color: '#ffffff',
                roughness: material.roughness,
                metalness: material.metalness
            }
        
            this.debugFolder.addBinding(params, 'color').on('change', (ev) => {
                material.color.set(ev.value)
            })
        
            this.debugFolder.addBinding(params, 'roughness', {
                min: 0,
                max: 1,
                step: 0.01
            }).on('change', (ev) => {
                material.roughness = ev.value
            })
        
            this.debugFolder.addBinding(params, 'metalness', {
                min: 0,
                max: 1,
                step: 0.01
            }).on('change', (ev) => {
                material.metalness = ev.value
            })
        }

        geojson.features.forEach(feature => {

            const raw = feature.geometry.coordinates
            const coords = Array.isArray(raw[0][0]) ? raw[0][0] : raw[0]

            const height = feature.properties.h || 1

            const shape = new Shape()

            let sx = 0
            let sz = 0
            let count = 0

            coords.forEach((c, i) => {
                const x = -c[0]
                const z = -c[1]

                sx += x
                sz += z
                count++

                if (i === 0) shape.moveTo(x, z)
                else shape.lineTo(x, z)
            })

            const centerX = sx / count
            const centerZ = sz / count

            const geometry = new ExtrudeGeometry(shape, {
                depth: height,
                bevelEnabled: false
            })

            geometry.rotateX(Math.PI / 2)
            geometry.center()

            const mesh = new Mesh(geometry, material)

            const y = terrain.getHeightAt(centerX, centerZ)
            mesh.position.set(centerX, y, centerZ)

            this.scene.add(mesh)
        })
    }

    update() {
    }

    destroy() { }
}